// ONE_EM constant used to go between "em" units used in style spec and "points" used internally for layout

const ONE_EM: number = 24;
export default ONE_EM;
